const Theme = {
  fonts: {
    body: "Poppins",
  },
  colors: {
    backgrounds: {
      orange: "#FA6400",
      darkGrey: "#292929",
    },
    borders: {
      gray: "#a4a4a4",
    },
    buttoncolors: {
      light: "#FFFFFF",
      grayBorder: "#f5f5f5",
    },
    fontcolors: {
      body: "#000000",
      secondary: "#FA6400",
      gray: "#A4A4A4",
    },
  },
  breakpoints: {
    smallMobileDown: "(max-width: 350px)",
    mobile: "(min-width: 480px)",
    mobileDown: "(max-width: 480px)",
    small: "(min-width: 640px)",
    medium: "(min-width: 800px)",
    mediumDown: "(max-width: 800px)",
    desktop: "(min-width: 960px)",
    notDesktop: "(max-width: 960px)",
    largeDesktop: "(min-width: 1235px)",
  },
  layout: {
    large: "144rem",
  },
}

export default Theme
